import React, { useEffect, useRef, useState } from "react"
import {
  FacebookShareButton,
  WhatsappShareButton,
} from "react-share"
import FaceBookIcon from "./icons/FaceBookIcon" 
import LinkIcon from "./icons/LinkIcon"
import WhatsIcon from "./icons/WhatsIcon"

 

const ShareToSocial = ({ isShow, setIsShow,slug ,isArticle } : any ) => {
  const ref = useRef<HTMLDivElement>(null)
  const [shareUrl, setShareUrl] = useState("")
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    setShareUrl(
      isArticle
        ? `${window.location.origin}/media-center?slug=${slug}`
        : `${window.location.origin}${window.location.pathname}/${slug}`
    )
  }, [isArticle, slug])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsShow(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [setIsShow])

  const handleCopy = () => {
    if (navigator.clipboard && window.isSecureContext) {
      // Use Clipboard API if available
      navigator.clipboard.writeText(shareUrl).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    } else {
      // Fallback for iOS
      const textArea = document.createElement("textarea");
      textArea.value = shareUrl;
      textArea.style.position = "absolute";
      textArea.style.left = "-9999px";
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
  
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };
  

  return (
    <div ref={ref} className={`share_to_social ${isShow ? "shown" : ""}`}>
        <WhatsappShareButton url={shareUrl} className="share-button">
          <span className="_shape whatsApp"><WhatsIcon /></span>
        </WhatsappShareButton>
        <FacebookShareButton url={shareUrl} className="share-button">
          <span className="_shape"><FaceBookIcon /></span>
        </FacebookShareButton>
        <button onClick={handleCopy} className="share-button">
        <span className="_shape text-white "><LinkIcon /></span>
      </button>

      {copied && <span className="copy-message">Copied!</span>}
    </div>
  )
}

export default ShareToSocial
